var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import PartialSaveDialog from '@/components/shared/PartialSaveDialog.vue';
var PartialSaveMixin = /** @class */ (function (_super) {
    __extends(PartialSaveMixin, _super);
    function PartialSaveMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    /**
     * Open the partial save dialog
     * @param module Module to save to, e.g. Carrier
     * @param data  Data to save
     */
    PartialSaveMixin.prototype.openPartialSaveDialog = function (module, data) {
        this.store.partialSave.openDialog({ module: module, data: data });
    };
    PartialSaveMixin.prototype.redirectAndResumePartialSave = function (partialSave) {
        // set data & flag in the store
        this.store.partialSave.setPartialSaveToBeRestored({
            data: JSON.parse(partialSave.partialData),
        });
        // redirect
        this.$router.push(partialSave.endpoint);
    };
    PartialSaveMixin.prototype.getDataToBeRestored = function () {
        // get the data from the store
        var data = __assign({}, this.store.partialSave.data);
        // clean the store
        this.store.partialSave.clearPartialSaveAfterRestore();
        // return the data
        return data;
    };
    Object.defineProperty(PartialSaveMixin.prototype, "restoringPartialSave", {
        get: function () {
            return this.store.partialSave.restoring;
        },
        enumerable: false,
        configurable: true
    });
    PartialSaveMixin = __decorate([
        Component({
            components: {
                'partial-save-dialog': PartialSaveDialog,
            },
        })
    ], PartialSaveMixin);
    return PartialSaveMixin;
}(Vue));
export default PartialSaveMixin;
